var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"geo-object-label",class:{
      isolationZone: _vm.objectType === _setup.GeoObjectType.IsolationZone,
      multiplierGroup: _vm.objectType === _setup.GeoObjectType.MultiplierGroup,
    },style:(_setup.labelPosition)},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }